import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize } from 'rxjs/operators';
import { PRODUCT_IMAGES } from 'src/app/helpers/google-storage.helper';
import { ITEM_REVENUE_CATEGORY } from 'src/app/helpers/item-revenue.helper';
import { ORDER_CATEGORY } from 'src/app/helpers/order-categories.helper';
import { CartItems } from 'src/app/models/cart-items.model';
import { CompanyShoeInsoles } from 'src/app/models/company-shoe-insoles.model';
import { PagedCollectionResponse } from 'src/app/models/http/page-collection-response.model';
import { CartItemsRequest } from 'src/app/models/requests/cart-items-request.model';
import { CompanyShoeInsolesVM } from 'src/app/models/view-models/company-shoe-insoles-vm.model';
import { CartManagerService } from 'src/app/services/local/cart-manager.service';
import { LocalStorageService } from 'src/app/services/local/local-storage.service';
import { CompanyShoeInsolesService } from 'src/app/services/repositories/company-shoe-insoles.service';

@Component({
    selector: 'app-shoe-insoles',
    templateUrl: './shoe-insoles.component.html',
    styleUrls: ['./shoe-insoles.component.scss'],
    standalone: false
})
export class ShoeInsolesComponent implements OnInit {
  public toggleClass: boolean = true;
  public shoeInsoles: CompanyShoeInsoles[] = [];
  public shoeInsolesVM: CompanyShoeInsolesVM[] = [];
  public productImages = PRODUCT_IMAGES.shoeInsoles;

  private readonly N_ADD_TO_CART_TITLE = 'Add to Cart';
  private readonly N_ADD_TO_CART_SUCCESS_MSG = 'Cart item was added successfully!';
  private readonly N_ADD_TO_CART_WARN_MSG = 'You must add a shoe size and shoe width.';

  constructor(private _loaderService: NgxUiLoaderService,
              private _localStorageService: LocalStorageService,
              private _cartManagerService: CartManagerService,
              private _notificationService: ToastrService,
              private _companyShoeInsolesService: CompanyShoeInsolesService) { }

  ngOnInit(): void {
    this.loadShoeInsoles();
  }

  loadShoeInsoles() {
    this._loaderService.start();
    this._companyShoeInsolesService.getShoeInsoles()
    .pipe(
      finalize(() =>
        this._loaderService.stop())
    )
    .subscribe((data: PagedCollectionResponse<CompanyShoeInsoles>) => {
      if (this.shoeInsolesVM.length === 0) {
        this.shoeInsolesVM = data.items.map((item) => ({
          id: item.id,
          brand: item.brand,
          description: item.description,
          price: item.price,
          style: item.style,
          insoleImage: item.shoeInsoleImages.imagePairSide,
          shoeInsoleModels: item.shoeInsoleModels,
          selectedOption: item.shoeInsoleModels[0].sku
      }));
      }
    }, (error: any) => {
      console.log(error);
    });
  }

  addToCart(sku: string) {
    let shoeInsole = this.shoeInsolesVM.find(si => si.shoeInsoleModels.find(sim => sim.sku == sku));
    if (shoeInsole) {
      shoeInsole.shoeInsoleModels = shoeInsole.shoeInsoleModels.filter(sim => sim.sku == sku)
      let insoleDescription = `${shoeInsole.brand} ${shoeInsole.style} - ${shoeInsole.shoeInsoleModels[0].gender} Size: ${shoeInsole.shoeInsoleModels[0].sizeRange}`
      const cartItem : CartItemsRequest = {
        itemCategory: ORDER_CATEGORY.shoes,
        itemDescription: insoleDescription,
        itemImageName: shoeInsole.insoleImage,
        sku: shoeInsole.selectedOption,
        itemDetails: [{
                        id: shoeInsole.id,
                        itemType: ITEM_REVENUE_CATEGORY.shoeInsoles,
                        itemDescription: insoleDescription
                      }]
      }

      this._cartManagerService.addCartItem(cartItem)
      .subscribe((newCartItem: CartItems) => {
          if (newCartItem) {
            this._cartManagerService.saveNewCartItemRef(newCartItem);
          }
          this.showCartAddSuccess();
        },
        (error: any) => {
          this.showCartAddError();
        });

    };
  }

  showCartAddSuccess() {
    this._notificationService.success(this.N_ADD_TO_CART_SUCCESS_MSG, this.N_ADD_TO_CART_TITLE);
  }

  showCartAddError() {
    this._notificationService.warning(this.N_ADD_TO_CART_WARN_MSG, this.N_ADD_TO_CART_TITLE);
  }
}
